// EC Tool Works - Reliable Hardware Tools & Workshop Gear
// Brand operator: EC Capital Investments LLC
// Inspired by djonesonlinehardware.com

// ============================================
// SITE IMAGES - Hardware / Workshop Theme
// ============================================
export const siteImages = {
  heroMain: 'https://images.unsplash.com/photo-1583126162406-643011b3f69f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxwb3dlciUyMHRvb2xzJTIwd29ya3Nob3B8ZW58MHx8fGJsYWNrfDE3Nzg2ODA1MzJ8MA&ixlib=rb-4.1.0&q=85',
  heroSecondary: 'https://images.unsplash.com/photo-1614608939798-ea1f6b7babcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxoYXJkd2FyZSUyMHRvb2xzJTIwZGFya3xlbnwwfHx8YmxhY2t8MTc3ODY4MDUzMnww&ixlib=rb-4.1.0&q=85',
  heroLifestyle: 'https://images.unsplash.com/photo-1503424886307-b090341d25d1?q=80&w=2670&auto=format&fit=crop',
  ctaBackground: 'https://images.unsplash.com/photo-1581244277943-fe4a9c777189?q=80&w=2670&auto=format&fit=crop',
  featuredBackground: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?q=80&w=2670&auto=format&fit=crop',
  powerBackground: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?q=80&w=2670&auto=format&fit=crop',
  shopBanner: 'https://images.unsplash.com/photo-1581147036324-c1c89c2c8d92?q=80&w=2670&auto=format&fit=crop',
  aboutBanner: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?q=80&w=2670&auto=format&fit=crop',
  contactBanner: 'https://images.unsplash.com/photo-1581244277943-fe4a9c777189?q=80&w=2670&auto=format&fit=crop',
  returnsBanner: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?q=80&w=2670&auto=format&fit=crop',
  privacyBanner: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?q=80&w=2670&auto=format&fit=crop',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on all orders

export const CARD_DESCRIPTOR = '8336923788ectoolworks';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(833) 692-3788',
  email: 'contactus@ectoolworks.com',
  corpName: 'EC Capital Investments LLC',
  address: {
    street: '2212 N Sibley St',
    city: 'Metairie',
    state: 'LA',
    zip: '70003',
    country: 'United States'
  }
};

export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// HARDWARE PRODUCT CATALOG (45 Products)
// ============================================
// Original 14 hardware items at prices:
//   $9.63, $12.84, $19.26, $19.37, $28.89, $58.11, $77.48,
//   $142.16, $227.48, $318.72, $489.36, $612.44, $784.88, $999.00
// PLUS 31 home-repair-kit price points (for processor MID coverage):
//   $13.99, $33.00, $39.00, $43.00, $44.00, $48.75, $49.00, $50.00,
//   $55.00, $56.25, $57.00, $58.00, $60.00, $65.00, $70.00, $75.00,
//   $78.00, $80.00, $85.00, $90.00, $93.00, $99.00, $100.00, $101.00,
//   $105.00, $110.00, $125.00, $140.00, $150.00, $170.00, $195.00

export const products = [
  // ===== MEASUREMENT & DETECTION =====
  {
    id: "laser-range-finder",
    name: "Laser Range Finder",
    slug: "laser-range-finder",
    sku: "ECT-MEA-001",
    price: 9.63,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HY16AKJYJT4ETQT1836C16Z1.avif",
    badge: "Deal",
    categoryId: "measurement-detection",
    categorySlug: "measurement-detection",
    description: "This compact and easy-to-use device accurately measures distances up to 100 feet with a single push of a button. Perfect for contractors, DIYers and homeowners who need fast, precise readings on the job.",
    keyBenefits: ["Accurate distance readings up to 100 ft", "Compact pocket-sized design", "Single-button operation"],
    usage: "Point at any wall, surface or object and press the button to capture instant length, area or volume measurements.",
    features: ["100 ft Range", "Pocket-Sized", "Auto-Off", "LCD Display"],
    inStock: true
  },
  {
    id: "magnetic-stud-finder",
    name: "Magnetic Stud Finder",
    slug: "magnetic-stud-finder",
    sku: "ECT-MEA-002",
    price: 12.84,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HY16DD91P471HJ8W3ZAMA1CT.avif",
    badge: "Best Seller",
    categoryId: "measurement-detection",
    categorySlug: "measurement-detection",
    description: "Locate studs, metal pipes and live electrical wires behind walls with this versatile pocket-sized magnetic stud finder. No batteries required and no recalibration needed for fast hassle-free use.",
    keyBenefits: ["No batteries required", "Locates studs, pipes & wires", "Pocket-friendly form factor"],
    usage: "Slide along any drywall surface until the indicator snaps to a hidden metal fastener inside the stud.",
    features: ["Battery-Free", "Multi-Detection", "Compact", "No Calibration"],
    inStock: true
  },
  {
    id: "advanced-waterproof-voltage-tester",
    name: "Advanced Waterproof Voltage Tester",
    slug: "advanced-waterproof-voltage-tester",
    sku: "ECT-MEA-003",
    price: 58.11,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZQ71HRSDRQXAWW84MNTHA11.jpg",
    badge: "Pro Pick",
    categoryId: "measurement-detection",
    categorySlug: "measurement-detection",
    description: "Safely identify live circuits in wet or dusty conditions with this IP67-rated voltage tester. A bright LED tip and audible alert give electricians clear feedback on outlets, switches and junction boxes.",
    keyBenefits: ["IP67 waterproof rating", "Audible and visual alerts", "Auto-ranging AC/DC detection"],
    usage: "Touch the tip to any outlet, wire or terminal to instantly check for live voltage before service.",
    features: ["IP67 Rated", "AC/DC", "LED + Buzzer", "Auto-Range"],
    inStock: true
  },
  {
    id: "wall-stud-finder-lcd",
    name: "Wall Stud Finder with LCD Screen",
    slug: "wall-stud-finder-lcd",
    sku: "ECT-MEA-004",
    price: 227.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HRZ1N10CJ9HSYBP8KCNXG28V.webp",
    badge: "Premium",
    categoryId: "measurement-detection",
    categorySlug: "measurement-detection",
    description: "Cutting-edge electronic tool designed to locate studs, wires and pipes concealed within walls. The large LCD screen displays depth, material type and stud edges for accurate work on every project.",
    keyBenefits: ["Detects wood, metal & live wire", "Large backlit LCD display", "Shows stud center & edges"],
    usage: "Calibrate against the wall, then glide across the surface to map out studs and hidden utilities.",
    features: ["LCD Screen", "Multi-Mode", "Depth Detect", "Live Wire Alert"],
    inStock: true
  },
  {
    id: "precision-digital-clamp-meter-kit",
    name: "Precision Digital Clamp Meter Kit",
    slug: "precision-digital-clamp-meter-kit",
    sku: "ECT-MEA-005",
    price: 318.72,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZQ7SY21HJ8YQMCTXEX72MJ8.jpg",
    badge: "Pro Kit",
    categoryId: "measurement-detection",
    categorySlug: "measurement-detection",
    description: "This Precision Digital Clamp Meter Kit is a comprehensive solution for professional electricians. Measures AC/DC current, voltage, resistance, capacitance, frequency and temperature with True-RMS accuracy.",
    keyBenefits: ["True-RMS multimeter accuracy", "Auto-ranging across all modes", "Includes test leads & probes"],
    usage: "Clamp around any conductor to measure current, or use the probes for voltage, continuity and more.",
    features: ["True-RMS", "Auto-Range", "Multi-Function", "Probe Kit"],
    inStock: true
  },

  // ===== HAND TOOLS =====
  {
    id: "multifunction-auto-pipe-wrench",
    name: "Multifunction Auto Pipe Wrench",
    slug: "multifunction-auto-pipe-wrench",
    sku: "ECT-HND-001",
    price: 19.26,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVVF797E9J6F3NHSKS8JM7Q6.jpg",
    badge: "Popular",
    categoryId: "hand-tools",
    categorySlug: "hand-tools",
    description: "Unleash the power of convenience and efficiency with our Multifunction Auto Power Pipe Wrench. Self-adjusting jaws grip nuts, bolts, pipes and fittings of nearly any size — no fiddling required.",
    keyBenefits: ["Self-adjusting jaws", "Grips multiple shapes & sizes", "Heat-treated forged steel"],
    usage: "Clamp around any pipe, hex nut or bolt and turn — the auto-jaw grips tighter as you apply torque.",
    features: ["Auto-Grip", "Forged Steel", "Multi-Size", "Slip-Resistant"],
    inStock: true
  },
  {
    id: "air-paint-spray-gun-cleaning-brush",
    name: "Air Paint Spray Gun with Cleaning Brush",
    slug: "air-paint-spray-gun-cleaning-brush",
    sku: "ECT-HND-002",
    price: 19.37,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZQ3WJAQGMW4SNPXEQ2HF2NW.jpg",
    badge: "Best Value",
    categoryId: "hand-tools",
    categorySlug: "hand-tools",
    description: "Unlock the potential of precise, high-volume, low-pressure painting with our compact air paint spray gun kit. Includes nozzles, cup and a cleaning brush set for fast prep and easy teardown.",
    keyBenefits: ["HVLP smooth finish", "Quick-swap nozzles included", "Cleaning brush set included"],
    usage: "Connect to a standard air compressor and spray walls, furniture, cabinets or autobody panels with ease.",
    features: ["HVLP", "Multi-Nozzle", "Cup Included", "Cleaning Kit"],
    inStock: true
  },

  // ===== POWER TOOLS =====
  {
    id: "premium-diamond-hole-saw-crowns-kit",
    name: "Premium Diamond Hole Saw Crowns Kit",
    slug: "premium-diamond-hole-saw-crowns-kit",
    sku: "ECT-PWR-001",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYNXVW454W2ZT579TJYJYG4Y.jpg",
    badge: "Pro Pick",
    categoryId: "power-tools",
    categorySlug: "power-tools",
    description: "The Premium Diamond Hole Saw Crowns Kit is a professional-grade tool set designed to drill clean holes in tile, porcelain, glass, granite and stone. Includes multiple crown sizes and a guide.",
    keyBenefits: ["Cuts tile, glass & stone", "Diamond-grit crown edges", "Multi-size crown set"],
    usage: "Chuck a crown into your drill, add water for cooling and bore precise holes through hard materials.",
    features: ["Diamond Grit", "Multi-Size", "Wet/Dry", "Pro-Grade"],
    inStock: true
  },
  {
    id: "compact-cordless-drill-combo-kit",
    name: "Compact Cordless Drill Combo Kit",
    slug: "compact-cordless-drill-combo-kit",
    sku: "ECT-PWR-002",
    price: 489.36,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYNTBW7Y00YRCZDAXSS9FMNE.jpg",
    badge: "Top Pick",
    categoryId: "power-tools",
    categorySlug: "power-tools",
    description: "The Compact Cordless Drill Combo Kit is a versatile and essential tool kit for any home, workshop or job-site. Includes drill driver, impact driver, batteries, charger and a carrying case.",
    keyBenefits: ["Drill + impact driver combo", "Two lithium-ion batteries", "Heavy-duty carrying case"],
    usage: "Power through drilling, driving, fastening and assembly tasks with a brushless cordless platform.",
    features: ["Brushless Motor", "Lithium-Ion", "2-Tool Kit", "Tough Case"],
    inStock: true
  },
  {
    id: "professional-cordless-angle-grinder-pro-kit",
    name: "Professional Cordless Angle Grinder Pro Kit",
    slug: "professional-cordless-angle-grinder-pro-kit",
    sku: "ECT-PWR-003",
    price: 612.44,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYNXA0WXP7AF4KBY0CJSWD17.jpg",
    badge: "Pro Kit",
    categoryId: "power-tools",
    categorySlug: "power-tools",
    description: "The Professional Cordless Angle Grinder is a powerful and versatile tool designed for cutting, grinding and polishing metal, stone and masonry. Brushless motor delivers high RPM and long runtime.",
    keyBenefits: ["High-torque brushless motor", "Long-runtime battery system", "Cut, grind & polish on one tool"],
    usage: "Swap discs to cut rebar, grind welds, smooth concrete or polish steel — all on a single cordless platform.",
    features: ["Brushless", "Cordless", "Multi-Disc", "Pro-Duty"],
    inStock: true
  },

  // ===== WORKSHOP & STORAGE =====
  {
    id: "electrician-waist-bag-8-pockets",
    name: "8-Pockets Electrician Waist Bag",
    slug: "electrician-waist-bag-8-pockets",
    sku: "ECT-WSP-001",
    price: 28.89,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTQKNCVMAHTD7WZ7RKDV714T.jpg",
    badge: "Tradesman",
    categoryId: "workshop-storage",
    categorySlug: "workshop-storage",
    description: "Stay organized and efficient with our durable multi-compartment tool bag — the ultimate accessory for electricians, plumbers and contractors. Heavy-duty stitching, padded belt and 8 dedicated pockets.",
    keyBenefits: ["8 dedicated tool pockets", "Heavy-duty stitched build", "Adjustable padded belt"],
    usage: "Strap on at the job site to keep screwdrivers, pliers, meters and fasteners always at hand.",
    features: ["8 Pockets", "Padded Belt", "Heavy-Duty", "Tool Loops"],
    inStock: true
  },
  {
    id: "heavy-duty-workbench-with-pegboard",
    name: "Heavy-Duty Workbench with Pegboard",
    slug: "heavy-duty-workbench-with-pegboard",
    sku: "ECT-WSP-002",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HY16TH91HKEKZJ1G8KHFSXBE.avif",
    badge: "Workshop",
    categoryId: "workshop-storage",
    categorySlug: "workshop-storage",
    description: "Combine a rugged work surface with vertical tool organization using this workbench with attached pegboard. Solid wood top, steel frame and integrated hooks keep your shop tidy and productive.",
    keyBenefits: ["Solid wood work surface", "Built-in pegboard storage", "Steel-frame heavy-duty base"],
    usage: "Set up in any garage or workshop for woodworking, repairs, assembly and on-the-fly tool storage.",
    features: ["Solid Top", "Pegboard", "Steel Frame", "High Capacity"],
    inStock: true
  },
  {
    id: "rugged-tool-storage-system",
    name: "Rugged Heavy-Duty Tool Storage System",
    slug: "rugged-tool-storage-system",
    sku: "ECT-WSP-003",
    price: 784.88,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZQB0FT4HFRXTF33XANWN5Y9.jpg",
    badge: "Flagship",
    categoryId: "workshop-storage",
    categorySlug: "workshop-storage",
    description: "This Rugged Heavy-Duty Tool Storage System is designed to protect and organize your professional tool collection through years of demanding job-site use. Stackable, lockable and weatherproof.",
    keyBenefits: ["Weatherproof construction", "Stackable modular design", "Lockable & impact-resistant"],
    usage: "Stack and roll between job sites or anchor in the shop to securely store power tools and fasteners.",
    features: ["Weatherproof", "Stackable", "Lockable", "Heavy-Duty"],
    inStock: true
  },

  // ===== POWER & ENERGY =====
  {
    id: "high-efficiency-wind-turbine-generator",
    name: "High-Efficiency Wind Turbine Generator",
    slug: "high-efficiency-wind-turbine-generator",
    sku: "ECT-ENG-001",
    price: 999.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTQNFKPZKPXV91C7F651E6WE.jpg",
    badge: "Flagship",
    categoryId: "power-energy",
    categorySlug: "power-energy",
    description: "Maximize airflow and renewable power generation in your industrial or commercial space with our high-efficiency wind turbine generator. Heavy-gauge blades and a sealed generator core ensure years of off-grid service.",
    keyBenefits: ["High-efficiency turbine blades", "Sealed brushless generator", "Off-grid renewable output"],
    usage: "Mount on a rooftop, pole or off-grid cabin to charge battery banks and power lights, fans and appliances.",
    features: ["High Output", "Sealed Core", "Off-Grid", "Heavy-Duty"],
    inStock: true
  },

  // ============================================
  // ===== HOME REPAIR TOOL KITS (31 items) =====
  // Sourced from Walmart Home Repair Tools.
  // Pricing structured to span MID-friendly tiers:
  // 13.99, 33, 39, 43, 44, 48.75, 49, 50, 55, 56.25,
  // 57, 58, 60, 65, 70, 75, 78, 80, 85, 90, 93, 99,
  // 100, 101, 105, 110, 125, 140, 150, 170, 195
  // ============================================
  {
    id: "stubby-6in1-screwdriver",
    name: "Stubby 6-in-1 Multi-Bit Screwdriver",
    slug: "stubby-6in1-screwdriver",
    sku: "ECT-HRK-001",
    price: 13.99,
    image: "/products/walmart/stubby-6in1-screwdriver.jpg",
    badge: "Everyday",
    categoryId: "precision-kits",
    categorySlug: "precision-kits",
    description: "Compact stubby screwdriver with 6 interchangeable bits (Phillips and slotted in multiple sizes). Ideal for tight cabinets, electronics and quick household repairs where a full-length driver simply won't fit.",
    keyBenefits: ["6 driver bits in one tool", "Short shank fits tight spaces", "Magnetic bit holder"],
    usage: "Pop in the bit you need and tackle quick fixes around the home, office or appliance interior.",
    features: ["6-in-1 Bits", "Stubby", "Magnetic", "Ergonomic Grip"],
    inStock: true
  },
  {
    id: "hyper-tough-11pc-kit",
    name: "11-Piece Home Repair Tool Kit",
    slug: "hyper-tough-11pc-kit",
    sku: "ECT-HRK-002",
    price: 33.00,
    image: "/products/walmart/hyper-tough-11pc-kit.jpg",
    badge: "Starter",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "Compact 11-piece kit covering the essentials for basic home repair: hammer, pliers, tape measure, utility knife and an assortment of bits. Lightweight carry case keeps everything organized.",
    keyBenefits: ["Covers everyday home repairs", "Lightweight portable case", "Quality steel finish"],
    usage: "Grab and go for picture hanging, furniture assembly and small fixes around the apartment or dorm.",
    features: ["11 Pieces", "Carry Case", "Steel", "Beginner Friendly"],
    inStock: true
  },
  {
    id: "dekopro-42pc-pink",
    name: "42-Piece All-Purpose Pink Tool Set",
    slug: "dekopro-42pc-pink",
    sku: "ECT-HRK-003",
    price: 39.00,
    image: "/products/walmart/dekopro-42pc-pink.jpg",
    badge: "Gift Pick",
    categoryId: "pink-edition",
    categorySlug: "pink-edition",
    description: "A 42-piece pink tool kit built for everyday home repair. Includes claw hammer, screwdriver bits, pliers, tape measure and precision tools — all in a soft-grip pink finish and tidy storage case.",
    keyBenefits: ["42 essential tools", "Soft pink finish", "Compact storage case"],
    usage: "Perfect first toolkit for renters, students or anyone setting up a new household.",
    features: ["42 Pieces", "Pink Finish", "Storage Case", "All-Purpose"],
    inStock: true
  },
  {
    id: "hyper-tough-5in1-hammer-screwdriver",
    name: "5-in-1 Hammer & Screwdriver Combo Set",
    slug: "hyper-tough-5in1-hammer-screwdriver",
    sku: "ECT-HRK-004",
    price: 43.00,
    image: "/products/walmart/hyper-tough-5in1-hammer-screwdriver.jpg",
    badge: "Combo",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "Multi-function set pairing a steel claw hammer with a 4-bit interchangeable screwdriver. Two of the most-used tools in any home, packaged together as a thoughtful gift or starter combo.",
    keyBenefits: ["Hammer + driver in one set", "4 swap-in driver bits", "Forged steel claw head"],
    usage: "Drive nails, pull staples and turn screws on cabinets, frames and assembled furniture.",
    features: ["5-in-1", "Forged Steel", "Multi-Bit", "Gift-Ready"],
    inStock: true
  },
  {
    id: "hyper-tough-easy-care-6pc",
    name: "6-Piece Easy Care Tool Set",
    slug: "hyper-tough-easy-care-6pc",
    sku: "ECT-HRK-005",
    price: 44.00,
    image: "/products/walmart/hyper-tough-easy-care-6pc.jpg",
    badge: "Compact",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "Slim 10.5\" x 7.5\" x 1.25\" tray-style kit with the six tools you reach for most: hammer, screwdriver, pliers, tape measure, utility knife and bits. Stores flat in any drawer.",
    keyBenefits: ["Stores flat in a drawer", "Six everyday tools", "Color-coded handles"],
    usage: "Keep in a kitchen or office drawer for quick repairs without lugging a full toolbox.",
    features: ["6 Pieces", "Slim Tray", "Drawer Storage", "Easy Care"],
    inStock: true
  },
  {
    id: "hyper-tough-77pc-precision",
    name: "77-Piece Precision Tool Kit with Magnetic Driver",
    slug: "hyper-tough-77pc-precision",
    sku: "ECT-HRK-006",
    price: 48.75,
    image: "/products/walmart/hyper-tough-77pc-precision.jpg",
    badge: "Precision",
    categoryId: "precision-kits",
    categorySlug: "precision-kits",
    description: "Precision driver kit with 77 magnetic bits for electronics, phones, watches and small appliances. Comes with a magnetized handle, extension shaft and tweezers in a flip-open case.",
    keyBenefits: ["77 precision bits", "Magnetized handle", "Includes tweezers & extension"],
    usage: "Repair eyeglasses, smartphones, game consoles, drones and other small electronics with confidence.",
    features: ["77 Bits", "Magnetic", "Precision", "Electronics"],
    inStock: true
  },
  {
    id: "difflife-40pc",
    name: "40-Piece General Household Hand Tool Kit",
    slug: "difflife-40pc",
    sku: "ECT-HRK-007",
    price: 49.00,
    image: "/products/walmart/difflife-40pc.jpg",
    badge: "Value",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "40-piece household kit packed into a sturdy plastic toolbox. Includes claw hammer, adjustable wrench, screwdrivers, pliers, tape measure and a full bit assortment.",
    keyBenefits: ["40 home repair tools", "Sturdy plastic toolbox", "Chrome-plated finish"],
    usage: "Reach for it on weekends to tackle small projects, furniture builds and seasonal fixes.",
    features: ["40 Pieces", "Toolbox", "Chrome-Plated", "Household"],
    inStock: true
  },
  {
    id: "hyper-tough-40pc-seafoam",
    name: "40-Piece Seafoam Household Tool Kit",
    slug: "hyper-tough-40pc-seafoam",
    sku: "ECT-HRK-008",
    price: 50.00,
    image: "/products/walmart/hyper-tough-40pc-seafoam.jpg",
    badge: "Best Seller",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "Bright seafoam-finished 40-piece kit for basic repairs and DIY projects. Hammer, ratcheting driver, bits, sockets, pliers and a tape measure — every essential in one tray.",
    keyBenefits: ["40 essential tools", "Seafoam color-coded set", "Includes ratcheting driver"],
    usage: "Use for everyday DIY around the home, dorm room or first apartment.",
    features: ["40 Pieces", "Ratcheting Driver", "DIY", "Tray Case"],
    inStock: true
  },
  {
    id: "hyper-tough-40pc-purple",
    name: "40-Piece Purple General Household Tool Kit",
    slug: "hyper-tough-40pc-purple",
    sku: "ECT-HRK-009",
    price: 55.00,
    image: "/products/walmart/hyper-tough-40pc-purple.jpg",
    badge: "Trending",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "Same trusted 40-piece tool selection in a vibrant purple finish. Hammer, screwdriver, sockets, pliers and tape measure stored in a compact case.",
    keyBenefits: ["Bold purple color", "Compact storage tray", "40 daily-use tools"],
    usage: "Great gift for new homeowners or renters — distinct look, dependable everyday tools.",
    features: ["40 Pieces", "Purple", "Compact Case", "Gift"],
    inStock: true
  },
  {
    id: "household-105pc-toolset",
    name: "105-Piece General Household Tool Set",
    slug: "household-105pc-toolset",
    sku: "ECT-HRK-010",
    price: 56.25,
    image: "/products/walmart/household-105pc-toolset.jpg",
    badge: "Family",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "105-piece household tool set in a hard-shell storage case. Designed for everyday home repairs, DIY projects and craft work — wrenches, sockets, drivers and accessories included.",
    keyBenefits: ["105 versatile tools", "Hard-shell storage case", "DIY & craft ready"],
    usage: "Cover the bulk of any household repair, from leaky faucets to flat-pack furniture.",
    features: ["105 Pieces", "Hard Case", "DIY", "Crafts"],
    inStock: true
  },
  {
    id: "lzvxtym-pink",
    name: "Compact Pink Household Hand Tool Set",
    slug: "lzvxtym-pink",
    sku: "ECT-HRK-011",
    price: 57.00,
    image: "/products/walmart/lzvxtym-pink.jpg",
    badge: "For Her",
    categoryId: "pink-edition",
    categorySlug: "pink-edition",
    description: "Lightweight 1.58-lb pink household repair kit made of polished steel. Comes in a hard plastic case ideal for quick fixes in dorms, apartments or first homes.",
    keyBenefits: ["Steel construction", "Lightweight at 1.58 lbs", "Pink finish & case"],
    usage: "Pack it under the bathroom sink or kitchen drawer for quick everyday repairs.",
    features: ["Steel", "Lightweight", "Pink", "Hard Case"],
    inStock: true
  },
  {
    id: "hyper-tough-110pc",
    name: "110-Piece Home Project Tool Set",
    slug: "hyper-tough-110pc",
    sku: "ECT-HRK-012",
    price: 58.00,
    image: "/products/walmart/hyper-tough-110pc.jpg",
    badge: "Project Ready",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "110-piece home project tool set in a stackable storage case. Includes hammer, ratcheting driver, full bit set, sockets, hex keys, pliers and tape measure.",
    keyBenefits: ["110 tools & accessories", "Stackable storage case", "Full socket assortment"],
    usage: "Take on small renovations, furniture builds and weekend projects in one trip from the case.",
    features: ["110 Pieces", "Stackable Case", "Sockets", "Hex Keys"],
    inStock: true
  },
  {
    id: "storgener-56pc-precision",
    name: "56-Piece Precision Repair Tool Kit",
    slug: "storgener-56pc-precision",
    sku: "ECT-HRK-013",
    price: 60.00,
    image: "/products/walmart/storgener-56pc-precision.jpg",
    badge: "Tech Pick",
    categoryId: "precision-kits",
    categorySlug: "precision-kits",
    description: "56-piece precision screwdriver and repair kit for office, college and home electronics. Magnetic S2 steel bits work on laptops, phones, eyewear and gaming devices.",
    keyBenefits: ["S2 magnetic bits", "Electronics-grade precision", "Compact zip case"],
    usage: "Service laptops, tablets, eyewear and household electronics with the right bit every time.",
    features: ["56 Pieces", "S2 Steel", "Magnetic", "Electronics"],
    inStock: true
  },
  {
    id: "pink-123pc-usb-drill",
    name: "123-Piece Pink Tool Set with USB Cordless Drill",
    slug: "pink-123pc-usb-drill",
    sku: "ECT-HRK-014",
    price: 65.00,
    image: "/products/walmart/pink-123pc-usb-drill.jpg",
    badge: "Cordless",
    categoryId: "pink-edition",
    categorySlug: "pink-edition",
    description: "123-piece pink household tool set anchored by a lightweight 3.6V USB-rechargeable cordless drill. Adds drilling power to a complete kit of hand tools, sockets and bits.",
    keyBenefits: ["3.6V USB cordless drill", "123 mixed hand & power tools", "Portable & lightweight"],
    usage: "Drive long screws, drill pilot holes and finish assemblies without dragging out a corded drill.",
    features: ["USB Drill", "123 Pieces", "Pink", "Portable"],
    inStock: true
  },
  {
    id: "hyper-tough-99pc-electrical",
    name: "99-Piece Compact Electrical Home Repair Set",
    slug: "hyper-tough-99pc-electrical",
    sku: "ECT-HRK-015",
    price: 70.00,
    image: "/products/walmart/hyper-tough-99pc-electrical.jpg",
    badge: "Electrical",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "99-piece compact electrical repair set packed into a hard storage case. Wire connectors, cutters, drivers and basic test gear for outlet and fixture work.",
    keyBenefits: ["Electrical-focused tool mix", "Hard storage case", "Connectors & cutters included"],
    usage: "Swap outlets, install dimmers and finish low-voltage runs with one organized kit.",
    features: ["99 Pieces", "Electrical", "Storage Case", "Connectors"],
    inStock: true
  },
  {
    id: "catgood-105pc",
    name: "105-Piece Auto & Home Repair Tool Set",
    slug: "catgood-105pc",
    sku: "ECT-HRK-016",
    price: 75.00,
    image: "/products/walmart/catgood-105pc.jpg",
    badge: "Auto & Home",
    categoryId: "mechanic-sets",
    categorySlug: "mechanic-sets",
    description: "105-piece household and auto repair tool kit with essential hand tools — sockets, ratchets, hex keys, pliers, screwdrivers and a hammer in a molded case.",
    keyBenefits: ["Home + auto coverage", "Ratchets & sockets included", "Molded carry case"],
    usage: "Use under the hood for light auto work and around the house for furniture and fixture repairs.",
    features: ["105 Pieces", "Auto Tools", "Sockets", "Carry Case"],
    inStock: true
  },
  {
    id: "workpro-pink-106pc",
    name: "WORKPRO 106-Piece Pink Home Repair Kit",
    slug: "workpro-pink-106pc",
    sku: "ECT-HRK-017",
    price: 78.00,
    image: "/products/walmart/workpro-pink-106pc.jpg",
    badge: "Pink Ribbon",
    categoryId: "pink-edition",
    categorySlug: "pink-edition",
    description: "106-piece pink ribbon edition tool kit in a wide-mouth open storage bag. Built to support breast cancer awareness while delivering a full set of household-grade hand tools.",
    keyBenefits: ["Wide-mouth tool bag", "Pink ribbon cause edition", "106 chrome-plated tools"],
    usage: "Carry the bag from room to room or out to the car for any repair the day brings.",
    features: ["Tool Bag", "106 Pieces", "Pink Ribbon", "Chrome Finish"],
    inStock: true
  },
  {
    id: "workpro-pink-103pc",
    name: "WORKPRO 103-Piece Pink Ladies Tool Kit",
    slug: "workpro-pink-103pc",
    sku: "ECT-HRK-018",
    price: 80.00,
    image: "/products/walmart/workpro-pink-103pc.jpg",
    badge: "Pink Ribbon",
    categoryId: "pink-edition",
    categorySlug: "pink-edition",
    description: "103-piece pink ladies' home repair tool kit in a round zipper pouch. Long-lasting chrome finish, ergonomic grips and a full hand tool mix.",
    keyBenefits: ["Round zipper pouch", "Chrome long-life finish", "Comfort-grip handles"],
    usage: "Zip-and-go organization for DIY home maintenance, decorating and small repairs.",
    features: ["Zipper Pouch", "103 Pieces", "Chrome", "Comfort Grip"],
    inStock: true
  },
  {
    id: "difflife-136pc",
    name: "136-Piece Household Tool Kit with Toolbox",
    slug: "difflife-136pc",
    sku: "ECT-HRK-019",
    price: 85.00,
    image: "/products/walmart/difflife-136pc.jpg",
    badge: "Popular",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "136-piece general household hand tool kit packed in a heavy-duty plastic toolbox. Sockets, ratchets, drivers, pliers, hammer and tape measure included.",
    keyBenefits: ["Heavy-duty plastic toolbox", "136 mixed hand tools", "Sockets + ratchets"],
    usage: "Solid one-box solution for first-time homeowners or weekend project warriors.",
    features: ["136 Pieces", "Toolbox", "Sockets", "Household"],
    inStock: true
  },
  {
    id: "pink-149pc-toolset",
    name: "149-Piece Pink Basic Home Repair Kit",
    slug: "pink-149pc-toolset",
    sku: "ECT-HRK-020",
    price: 90.00,
    image: "/products/walmart/pink-149pc-toolset.jpg",
    badge: "Office & Home",
    categoryId: "pink-edition",
    categorySlug: "pink-edition",
    description: "149-piece pink home repair kit assembled for home, office and dorm. Includes hand tools, bits, sockets, fasteners and accessories in a stylish case.",
    keyBenefits: ["149 tools + accessories", "Includes fastener assortment", "Stylish pink case"],
    usage: "Run mixed tasks across home and office on a single, well-organized kit.",
    features: ["149 Pieces", "Fasteners", "Pink Case", "Office Ready"],
    inStock: true
  },
  {
    id: "cshidworld-148pc-red",
    name: "148-Piece Mechanic & Home Repair Tool Kit",
    slug: "cshidworld-148pc-red",
    sku: "ECT-HRK-021",
    price: 93.00,
    image: "/products/walmart/cshidworld-148pc-red.png",
    badge: "Mechanic",
    categoryId: "mechanic-sets",
    categorySlug: "mechanic-sets",
    description: "148-piece mechanic and home repair tool kit in a deep red plastic toolbox. Loaded with sockets, ratchets, drivers, pliers and essential fasteners for serious DIY and light auto work.",
    keyBenefits: ["Deep red plastic toolbox", "148 home + mechanic tools", "Sockets & ratchets"],
    usage: "Garage-grade kit for home, shop and office repairs that need a bit more torque and reach.",
    features: ["148 Pieces", "Mechanic Set", "Red Toolbox", "Sockets"],
    inStock: true
  },
  {
    id: "cartman-148pc-blue",
    name: "Cartman 148-Piece General Household Tool Kit",
    slug: "cartman-148pc-blue",
    sku: "ECT-HRK-022",
    price: 99.00,
    image: "/products/walmart/cartman-148pc-blue.jpg",
    badge: "Top Pick",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "148-piece general household hand tool kit in a blue stackable toolbox. Includes sockets, ratchets, hex keys, drivers, pliers, hammer and tape measure.",
    keyBenefits: ["Blue stackable toolbox", "148 multi-purpose tools", "Sockets + hex keys"],
    usage: "Reliable single-box kit covering most home repair and basic auto work scenarios.",
    features: ["148 Pieces", "Toolbox", "Sockets", "Hex Keys"],
    inStock: true
  },
  {
    id: "hyper-tough-89pc-pink-bag",
    name: "89-Piece Pink Household Tool Set with 12-Pocket Bag",
    slug: "hyper-tough-89pc-pink-bag",
    sku: "ECT-HRK-023",
    price: 100.00,
    image: "/products/walmart/hyper-tough-89pc-pink-bag.jpg",
    badge: "Tradesman Pink",
    categoryId: "pink-edition",
    categorySlug: "pink-edition",
    description: "89-piece pink household tool set packed inside a 12-pocket tool bag. Carry it room-to-room with all your essentials visible and ready.",
    keyBenefits: ["12-pocket carry bag", "89 essential tools", "Pink finish"],
    usage: "Take the bag to any project zone — pockets keep tools sorted and within reach.",
    features: ["12 Pockets", "89 Pieces", "Pink", "Tool Bag"],
    inStock: true
  },
  {
    id: "jellas-242pc",
    name: "242-Piece Mechanic & Household Tool Kit",
    slug: "jellas-242pc",
    sku: "ECT-HRK-024",
    price: 101.00,
    image: "/products/walmart/jellas-242pc.png",
    badge: "Mega Kit",
    categoryId: "mechanic-sets",
    categorySlug: "mechanic-sets",
    description: "242-piece mechanic and household tool kit in a plastic toolbox. Includes a deep socket assortment, drivers, pliers, hammer, knife and a complete bit set.",
    keyBenefits: ["242 pieces in one box", "Deep socket assortment", "Home + mechanic coverage"],
    usage: "Outfit a garage, workshop or DIY room with everything needed for big and small projects.",
    features: ["242 Pieces", "Mechanic", "Deep Sockets", "Toolbox"],
    inStock: true
  },
  {
    id: "household-240pc",
    name: "240-Piece Household Tool Box Set",
    slug: "household-240pc",
    sku: "ECT-HRK-025",
    price: 105.00,
    image: "/products/walmart/household-240pc.jpg",
    badge: "Workshop",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "240-piece household tool box loaded with sockets, ratchets, hex keys, drivers, pliers and fasteners. Designed for serious DIYers who want every tool on hand.",
    keyBenefits: ["240 mixed tools", "Sockets + ratchets", "Heavy plastic toolbox"],
    usage: "Stock your workshop with one ready-to-go solution covering most repair needs.",
    features: ["240 Pieces", "Workshop Ready", "Sockets", "Fasteners"],
    inStock: true
  },
  {
    id: "prostormer-159pc",
    name: "PROSTORMER 159-Piece Home Repair Tool Set",
    slug: "prostormer-159pc",
    sku: "ECT-HRK-026",
    price: 110.00,
    image: "/products/walmart/prostormer-159pc.jpg",
    badge: "DIY Pro",
    categoryId: "home-repair-kits",
    categorySlug: "home-repair-kits",
    description: "159-piece general household hand tool kit ideal for apartments, garages, dorms and offices. Heavy-gauge tool box with a complete hand tool assortment.",
    keyBenefits: ["159 mixed tools", "Heavy-gauge toolbox", "Apartment to garage ready"],
    usage: "One-and-done kit for managers and supers maintaining apartments or small commercial spaces.",
    features: ["159 Pieces", "Toolbox", "Pro DIY", "Mixed Set"],
    inStock: true
  },
  {
    id: "performance-tool-119pc",
    name: "Performance Tool 119-Piece SAE/Metric Multi-Use Set",
    slug: "performance-tool-119pc",
    sku: "ECT-HRK-027",
    price: 125.00,
    image: "/products/walmart/performance-tool-119pc.jpg",
    badge: "SAE + Metric",
    categoryId: "mechanic-sets",
    categorySlug: "mechanic-sets",
    description: "119-piece SAE and metric multi-use tool set for general household and auto repair. Sockets, ratchets, drivers, pliers and a full bit set in a gray plastic toolbox.",
    keyBenefits: ["119 SAE + metric tools", "Auto + household ready", "Gray plastic toolbox"],
    usage: "Service both imported and domestic vehicles plus household fixtures with one organized kit.",
    features: ["119 Pieces", "SAE + Metric", "Auto", "Toolbox"],
    inStock: true
  },
  {
    id: "hyper-tough-36pc-impact-socket",
    name: "36-Piece 1/2\" Drive Metric Impact Socket Set",
    slug: "hyper-tough-36pc-impact-socket",
    sku: "ECT-HRK-028",
    price: 140.00,
    image: "/products/walmart/hyper-tough-36pc-impact-socket.jpg",
    badge: "Impact",
    categoryId: "mechanic-sets",
    categorySlug: "mechanic-sets",
    description: "36-piece 1/2-inch drive metric impact socket set made from CRMO steel for use with impact wrenches. Includes shallow and deep sockets in a molded case.",
    keyBenefits: ["1/2\" drive impact-rated", "CRMO impact steel", "Shallow + deep sockets"],
    usage: "Pair with any 1/2-inch impact wrench for automotive, equipment and heavy-duty maintenance.",
    features: ["CRMO Steel", "Impact Rated", "1/2\" Drive", "Metric"],
    inStock: true
  },
  {
    id: "cshidworld-171pc-socket",
    name: "171-Piece Socket Wrench Auto Repair Tool Kit",
    slug: "cshidworld-171pc-socket",
    sku: "ECT-HRK-029",
    price: 150.00,
    image: "/products/walmart/cshidworld-171pc-socket.png",
    badge: "Mechanic Pro",
    categoryId: "mechanic-sets",
    categorySlug: "mechanic-sets",
    description: "171-piece socket wrench combination kit built around a 1/4\" ratchet wrench. Deep socket and bit assortment for serious auto repair and household mechanic work.",
    keyBenefits: ["1/4\" ratchet wrench center", "171 mixed tools", "Auto repair grade"],
    usage: "Service vehicles, lawn equipment and shop machinery from one well-stocked case.",
    features: ["171 Pieces", "1/4\" Ratchet", "Sockets", "Auto"],
    inStock: true
  },
  {
    id: "prostormer-198pc",
    name: "PROSTORMER 198-Piece DIY Home & Car Repair Kit",
    slug: "prostormer-198pc",
    sku: "ECT-HRK-030",
    price: 170.00,
    image: "/products/walmart/prostormer-198pc.jpg",
    badge: "Power DIY",
    categoryId: "mechanic-sets",
    categorySlug: "mechanic-sets",
    description: "198-piece DIY home and car repair kit including hammer, pliers, screwdriver set, wrenches and sockets — all in a stackable plastic toolbox.",
    keyBenefits: ["198 mixed tools", "Home + car coverage", "Stackable toolbox"],
    usage: "Take on serious DIY across the house, garage and driveway with a single comprehensive kit.",
    features: ["198 Pieces", "DIY + Auto", "Stackable", "Toolbox"],
    inStock: true
  },
  {
    id: "workpro-408pc",
    name: "WORKPRO 408-Piece Auto & Home Repair Tool Set",
    slug: "workpro-408pc",
    sku: "ECT-HRK-031",
    price: 195.00,
    image: "/products/walmart/workpro-408pc.jpg",
    badge: "Flagship Kit",
    categoryId: "mechanic-sets",
    categorySlug: "mechanic-sets",
    description: "408-piece auto repair and household tool set in a 3-drawer heavy-duty metal box. Sockets, ratchets, drivers, pliers, wrenches and a deep accessory mix — the flagship home repair kit.",
    keyBenefits: ["3-drawer heavy-duty metal box", "408 home + mechanic tools", "Full pro-level coverage"],
    usage: "Equip a serious home garage, mobile service van or maintenance team with one flagship kit.",
    features: ["408 Pieces", "Metal Box", "3-Drawer", "Pro Grade"],
    inStock: true
  },
];

// ============================================
// CATEGORIES (9)
// ============================================
export const categories = [
  {
    id: "measurement-detection",
    name: "Measurement & Detection",
    slug: "measurement-detection",
    description: "Laser range finders, stud finders, voltage testers and clamp meters for accurate readings",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZQ7SY21HJ8YQMCTXEX72MJ8.jpg",
    productCount: 5
  },
  {
    id: "hand-tools",
    name: "Hand Tools",
    slug: "hand-tools",
    description: "Pipe wrenches, spray guns and everyday workshop hand tools built for daily use",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVVF797E9J6F3NHSKS8JM7Q6.jpg",
    productCount: 2
  },
  {
    id: "power-tools",
    name: "Power Tools",
    slug: "power-tools",
    description: "Cordless drills, angle grinders and diamond hole saw kits for serious projects",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYNXA0WXP7AF4KBY0CJSWD17.jpg",
    productCount: 3
  },
  {
    id: "workshop-storage",
    name: "Workshop & Storage",
    slug: "workshop-storage",
    description: "Workbenches, tool storage systems and tradesman pouches to keep your shop organized",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HY16TH91HKEKZJ1G8KHFSXBE.avif",
    productCount: 3
  },
  {
    id: "power-energy",
    name: "Power & Energy",
    slug: "power-energy",
    description: "Wind turbines and renewable generators for off-grid power and industrial airflow",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTQNFKPZKPXV91C7F651E6WE.jpg",
    productCount: 1
  },
  {
    id: "home-repair-kits",
    name: "Home Repair Kits",
    slug: "home-repair-kits",
    description: "General household tool kits — starter sets, color editions and full project kits for everyday DIY",
    image: "/products/walmart/cartman-148pc-blue.jpg",
    productCount: 13
  },
  {
    id: "pink-edition",
    name: "Pink Edition",
    slug: "pink-edition",
    description: "Pink ribbon tool sets — household repair kits with a soft pink finish, built for any toolkit owner",
    image: "/products/walmart/hyper-tough-89pc-pink-bag.jpg",
    productCount: 7
  },
  {
    id: "precision-kits",
    name: "Precision Kits",
    slug: "precision-kits",
    description: "Precision driver kits for electronics, eyewear, smartphones and small-appliance repair",
    image: "/products/walmart/hyper-tough-77pc-precision.jpg",
    productCount: 3
  },
  {
    id: "mechanic-sets",
    name: "Mechanic Sets",
    slug: "mechanic-sets",
    description: "Auto-repair and heavy-duty mechanic tool sets with sockets, ratchets and impact-rated tools",
    image: "/products/walmart/workpro-408pc.jpg",
    productCount: 8
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Pro-Grade Hardware', description: 'Hand-picked tools trusted by contractors, electricians and DIYers' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS Standard Shipping on every order' },
  { id: 3, title: '30-Day Returns', description: 'Easy returns within 30 days, no hassle' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and protected customer data' }
];

export const performanceBenefits = [
  { id: 1, title: 'Built for Strength', description: 'Forged steel, brushless motors and heavy-duty hardware made to last' },
  { id: 2, title: 'Precision Engineered', description: 'Accurate measurements and clean cuts on every job' },
  { id: 3, title: 'Trade Trusted', description: 'Reliable gear that keeps electricians and contractors moving' },
  { id: 4, title: 'Honest Pricing', description: 'Fair prices on the hardware you actually need' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated lineup of reliable hardware tools and workshop gear.' },
  { id: 2, title: 'Pick', description: 'Choose the tools, power gear or storage that fits your project.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with secure, encrypted payment.' },
  { id: 4, title: 'Build', description: 'Unbox, gear up and build with confidence.' }
];
